export default __webpack_public_path__ + "static/media/serviceontario-marked.3e53cc48.png";